export default "__VITE_ASSET__CsAvEfWc__"